import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actionCreators } from "../../store/Location";
import Pagination from '../Pagination';
import Breadcrumb from '../BreadcrumbMenu';
import Search from "../Search";
import PropTypes from "prop-types";

class LocationList extends Component{

  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
    this.searchLoadAll = this.searchLoadAll.bind(this);
  }

  componentDidMount(){
    if (this.props.display.length === 0){
      this.props.requestLocations();
    }
  }

  handleClick(event){
    let id = event.currentTarget.getAttribute("id");
    this.props.history.push("/locations/" + id);
  }

  searchLoadAll(event){
    this.props.clearStatePreserveSearch();
    this.props.requestLocations();
  }
  
  render(){
    return(
      <div>
        <Breadcrumb/>

        <div className="container-header">
          <div className="header-start">
            <h3>Locations</h3>
          </div>
          <div className="header-end">
            <Search setSearch={this.props.setSearch} search={this.props.search} requestRecords={this.props.requestLocations} clearState={this.props.clearState}/>
          </div>
        </div>

        <div className="centered-container border">
          <div className="container-body">
            <table className="cdb-table">
              <tbody>
              <tr>
                <th>Status</th>
                <th>Store #</th>
                <th>Name</th>
                <th>Street</th>
                <th>City</th>
                <th>State</th>
                <th>Zip</th>
                <th>Region</th>
              </tr>
              {this.props.display.map((loc) => {
                return(
                  <tr key={loc.id} onClick={this.handleClick} id={loc.fileMakerId}>
                    <td>{loc.status}</td>
                    <td>{loc.storeNumber}</td>
                    <td>{loc.name}</td>
                    <td>{loc.address}</td>
                    <td>{loc.city}</td>
                    <td>{loc.state}</td>
                    <td>{loc.zip}</td>
                    <td> </td>
                  </tr>
                );
              })}
              </tbody>
            </table>
          </div>
        </div>

        {this.props.search !== '' && !this.props.paginate ?
          <div style={{display: 'flex', justifyContent: 'center'}}>
            <button className="btn-primary btn-lg" onClick={this.searchLoadAll}
                    style={{width: '200px'}}>Load All Results
            </button>
          </div>
          : ''
        }

        {this.props.paginate ?
          <Pagination paginateFunc={this.props.requestLocations} currentPage={this.props.currentPage}
                      pageCount={this.props.pageCount}/>
          : ''
        }
      </div>
    );
  }
}

LocationList.propTypes = {
  display: PropTypes.array.isRequired,
  currentPage: PropTypes.number.isRequired,
  pageCount: PropTypes.number.isRequired,
  requestLocations: PropTypes.func.isRequired,
  search: PropTypes.string,
  setSearch: PropTypes.func.isRequired,
  clearState: PropTypes.func.isRequired,
  clearStatePreserveSearch: PropTypes.func.isRequired,
  paginate: PropTypes.bool.isRequired
};

function mapStateToProps(state){
  return {
    oidc: state.oidc,
    display: state.locations.display,
    currentPage: state.locations.page,
    pageCount: state.locations.pageCount,
    search: state.locations.search,
    paginate: state.locations.paginate
  }
}

export default connect(mapStateToProps,
  dispatch => bindActionCreators(actionCreators, dispatch))(LocationList);